import {
    FETCH_BIOMETRIC_POWER_ZONES,
    FETCH_BIOMETRIC_POWER_ZONES_SUCCESS,
    FETCH_BIOMETRIC_POWER_ZONES_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    powerZones: {},
    isPowerZonesFetching: false,
    didPowerZonesFetchFailing: false
};

// ======= Fetching Handlers =======
const fetchPowerZonesRequested = (state, action) => {
    return {
        powerZones: {
            ...state.powerZones
        },
        isPowerZonesFetching: true,
        didPowerZonesFetchFailing: false
    };
};

const fetchPowerZonesSuccess = (state, action) => {
    let powerZonesBySport = {};

    action.powerZones.map((powerZone) => {
        return (powerZonesBySport[powerZone.sport] = powerZone);
    });

    return {
        powerZones: {
            ...powerZonesBySport
        },
        isPowerZonesFetching: false,
        didPowerZonesFetchFailing: false
    };
};

const fetchPowerZonesFail = (state, action) => {
    return {
        powerZones: {
            ...state.powerZones
        },
        isPowerZonesFetching: false,
        didPowerZonesFetchFailing: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_BIOMETRIC_POWER_ZONES]: fetchPowerZonesRequested,
    [FETCH_BIOMETRIC_POWER_ZONES_SUCCESS]: fetchPowerZonesSuccess,
    [FETCH_BIOMETRIC_POWER_ZONES_FAIL]: fetchPowerZonesFail
};

// ======= Default Action =======
export default function powerZones(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchPowerZones(evictCache, doNotGenerateDefaults) {
    return {
        type: FETCH_BIOMETRIC_POWER_ZONES,
        doNotGenerateDefaults,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getPowerZoneBySport = (state, sportType) => {
    let retVal = null;

    if (state.powerZones.powerZones) {
        if (state.powerZones.powerZones[sportType]) {
            retVal = state.powerZones.powerZones[sportType];
        } else if (state.powerZones.powerZones['DEFAULT']) {
            retVal = state.powerZones.powerZones['DEFAULT'];
        }
    }

    return retVal;
};

export const getAllPowerZones = (state) => {
    let retVal = null;

    if (state.powerZones.powerZones) {
        retVal = state.powerZones.powerZones;
    }

    return retVal;
};

export const isPowerZonesFetching = (state) => {
    return state.powerZones.isPowerZonesFetching;
};

export const didPowerZonesFetchFailing = (state) => {
    return state.powerZones.didPowerZonesFetchFailing;
};
